<template>
  <div class="sf-subnav-item sf-level-item">
    <a
      :id="id"
      :class="{ active }"
      role="button"
      tabindex="0"
      @click.stop="clicked"
    >
      <span class="sf-font-s sf-pad-t-1 sf-pad-b-1">
        <slot />
      </span>
    </a>
  </div>
</template>

<script setup lang="ts">
interface Props {
  id: string
  active: boolean
}

defineProps<Props>()

const emit = defineEmits<{ click: [] }>()

function clicked() {
  emit('click')
}
</script>
